import React, { createContext, useContext, useState, useEffect } from 'react';

// Definim tipurile pentru traduceri
interface Translations {
  [key: string]: {
    [key: string]: string;
  };
}

// Traducerile pentru toate limbile suportate
const translations: Translations = {
  ro: {
    // Header
    'header.home': 'Acasă',
    'header.books': 'Cărți',
    'header.recommendations': 'Recomandări',
    'header.favorites': 'Favorite',
    'header.copyright': 'Copyright',
    'header.profile': 'Profilul meu',
    'header.logout': 'Deconectare',
    'header.login': 'Autentificare',
    'header.register': 'Înregistrare',
    
    // Hero Section
    'hero.title': 'Descoperă lumea cunoașterii prin',
    'hero.subtitle': 'Biblioteca Digitală',
    'hero.description': 'Accesează o colecție vastă de cărți, jurnale academice și materiale multimedia. Toate resursele sunt disponibile online, gratuit.',
    'hero.explore': 'Explorează biblioteca',
    'hero.about': 'Despre noi',
    'hero.changeLanguage': 'Schimbă limba',
    'hero.languageDescription': 'Selectează limba preferată pentru interfață',
    
    // Language Selector
    'language.select': 'Selectează limba',
    'language.help': 'Ajutor traducere',
    'language.comingSoon': 'În curând',
    
    // Search
    'search.placeholder': 'Caută cărți, autori, categorii...',
    'search.button': 'Caută',
    'search.advanced': 'Căutare avansată',
    'search.hideAdvanced': 'Ascunde căutarea avansată',
    'search.resultsFor': 'Rezultate pentru',
    'search.noResults': 'Nu s-au găsit rezultate pentru',
    'search.tryAnother': 'Încearcă o altă căutare sau explorează categoriile de mai jos.',
    'search.title': 'Titlu',
    'search.author': 'Autor',
    'search.category': 'Categorie',
    'search.year': 'An publicare',
    'search.language': 'Limba',
    'search.from': 'De la',
    'search.to': 'Până la',
    'search.apply': 'Aplică filtrele',
    'search.clear': 'Șterge filtrele',
    'search.selectCategory': 'Selectează categoria',
    'search.selectLanguage': 'Selectează limba',
    
    // Tabs
    'tabs.booksCategories': 'Cărți și Categorii',
    'tabs.specialCollections': 'Colecții Speciale',
    'tabs.recommendations': 'Recomandări Personalizate',
    'tabs.resources': 'Resurse Integrate',
    
    // Categories
    'categories.popular': 'Categorii populare',
    'categories.fiction': 'Ficțiune',
    'categories.nonFiction': 'Non-Ficțiune',
    'categories.science': 'Științifice',
    'categories.academic': 'Academice',
    'categories.biography': 'Biografii',
    'categories.poetry': 'Poezie',
    'categories.resources': 'resurse',
    
    // Books
    'books.recentlyAdded': 'Cărți adăugate recent',
    'books.readMore': 'Citește mai mult',
    'books.readLess': 'Citește mai puțin',
    'books.pages': 'pagini',
    'books.year': 'An',
    'books.language': 'Limba',
    'books.category': 'Categorie',
    'books.addToFavorites': 'Adaugă la favorite',
    'books.removeFromFavorites': 'Elimină din favorite',
    'books.download': 'Descarcă',
    'books.preview': 'Previzualizare',
    'books.details': 'Detalii',
    
    // Book Reader
    'reader.title': 'Cititor de cărți',
    'reader.page': 'Pagina',
    'reader.of': 'din',
    'reader.previousPage': 'Pagina anterioară',
    'reader.nextPage': 'Pagina următoare',
    'reader.close': 'Închide',
    'reader.bookmark': 'Marcaj',
    'reader.notes': 'Notițe',
    'reader.search': 'Caută în carte',
    'reader.fontSize': 'Mărimea fontului',
    'reader.nightMode': 'Mod noapte',
    
    // Special Collections
    'collections.title': 'Colecții Speciale',
    'collections.viewAll': 'Vezi toate',
    'collections.items': 'elemente',
    'collections.featured': 'Evidențiate',
    'collections.rareManuscripts': 'Manuscrise Rare',
    'collections.historicalMaps': 'Hărți Istorice',
    'collections.oldNewspapers': 'Ziare Vechi',
    'collections.type': 'Tipul',
    'collections.year': 'Anul',
    
    // Recommendations
    'recommendations.title': 'Recomandări Personalizate',
    'recommendations.forYou': 'Pentru tine',
    'recommendations.basedOnHistory': 'Bazat pe istoricul tău recent',
    'recommendations.popularInGenre': 'Populare în categoriile preferate',
    'recommendations.newArrivals': 'Noi sosiri',
    'recommendations.trending': 'În trend',
    'recommendations.becauseYouRead': 'Pentru că ai citit',
    'recommendations.similarReaders': 'Cititori cu gusturi similare au ales',
    'recommendations.loginRequired': 'Autentifică-te pentru recomandări personalizate',
    
    // External Resources
    'resources.title': 'Resurse Integrate',
    'resources.externalLibraries': 'Biblioteci externe',
    'resources.available': 'Disponibil',
    'resources.restricted': 'Acces restricționat',
    'resources.subscription': 'Abonament necesar',
    'resources.book': 'Carte',
    'resources.article': 'Articol',
    'resources.thesis': 'Teză',
    'resources.audio': 'Audio',
    'resources.video': 'Video',
    'resources.source': 'Sursa',
    'resources.openExternal': 'Deschide în bibliotecă externă',
    
    // User Reviews
    'reviews.title': 'Recenzii utilizatori',
    'reviews.addReview': 'Adaugă o recenzie',
    'reviews.rating': 'Evaluare',
    'reviews.writeReview': 'Scrie o recenzie',
    'reviews.submit': 'Trimite recenzia',
    'reviews.like': 'Îmi place',
    'reviews.reply': 'Răspunde',
    'reviews.likes': 'aprecieri',
    'reviews.replies': 'răspunsuri',
    'reviews.loginToReview': 'Autentifică-te pentru a lăsa o recenzie',
    'reviews.helpful': 'Util',
    'reviews.notHelpful': 'Nu este util',
    
    // User Profile
    'profile.title': 'Profilul meu',
    'profile.edit': 'Editează profilul',
    'profile.reading': 'În curs de citire',
    'profile.completed': 'Citite',
    'profile.favorites': 'Favorite',
    'profile.reviews': 'Recenziile mele',
    'profile.settings': 'Setări',
    'profile.privacy': 'Confidențialitate',
    'profile.notifications': 'Notificări',
    'profile.preferences': 'Preferințe',
    
    // Authentication
    'auth.login': 'Autentificare',
    'auth.register': 'Înregistrare',
    'auth.email': 'Email',
    'auth.password': 'Parolă',
    'auth.confirmPassword': 'Confirmă parola',
    'auth.firstName': 'Prenume',
    'auth.lastName': 'Nume',
    'auth.rememberMe': 'Ține-mă minte',
    'auth.forgotPassword': 'Am uitat parola',
    'auth.noAccount': 'Nu ai cont?',
    'auth.hasAccount': 'Ai deja cont?',
    'auth.loginError': 'Email sau parolă incorectă',
    'auth.registerSuccess': 'Cont creat cu succes',
    'auth.logout': 'Deconectare',
    
    // Forms
    'form.required': 'Câmp obligatoriu',
    'form.invalidEmail': 'Email invalid',
    'form.passwordTooShort': 'Parola trebuie să aibă cel puțin 6 caractere',
    'form.passwordsNotMatch': 'Parolele nu se potrivesc',
    'form.save': 'Salvează',
    'form.cancel': 'Anulează',
    'form.edit': 'Editează',
    'form.delete': 'Șterge',
    'form.confirm': 'Confirmă',
    
    // Copyright
    'copyright.title': 'Protecția Drepturilor de Autor',
    'copyright.description': 'Biblioteca noastră digitală respectă și protejează drepturile de autor pentru toate materialele disponibile.',
    'copyright.learnMore': 'Află mai multe despre politicile noastre de copyright',
    'copyright.fairUse': 'Utilizare echitabilă',
    'copyright.educational': 'Utilizare educațională',
    'copyright.publicDomain': 'Domeniu public',
    'copyright.restrictions': 'Restricții de utilizare',
    'copyright.contact': 'Contact pentru drepturi',
    
    // Accessibility
    'accessibility.title': 'Opțiuni de Accesibilitate',
    'accessibility.description': 'Personalizează experiența de citire pentru nevoi speciale',
    'accessibility.available': 'Accesibilitate disponibilă',
    'accessibility.openPanel': 'Deschide panelul de accesibilitate',
    'accessibility.closePanel': 'Închide panelul de accesibilitate',
    
    // Font Size
    'accessibility.fontSize': 'Mărimea textului',
    'accessibility.fontSize.small': 'Mic',
    'accessibility.fontSize.medium': 'Mediu',
    'accessibility.fontSize.large': 'Mare',
    'accessibility.fontSize.extra-large': 'Extra mare',
    'accessibility.fontSizeChanged': 'Mărimea textului a fost modificată',
    
    // Contrast
    'accessibility.contrast': 'Contrast',
    'accessibility.contrast.normal': 'Normal',
    'accessibility.contrast.high': 'Înalt',
    'accessibility.contrastChanged': 'Contrastul a fost modificat',
    
    // Text-to-Speech
    'accessibility.textToSpeech': 'Citire vocală',
    'accessibility.toggleTextToSpeech': 'Activează/dezactivează citirea vocală',
    'accessibility.testSpeech': 'Testează citirea vocală',
    'accessibility.stopSpeech': 'Oprește citirea',
    'accessibility.speaking': 'Citesc',
    'accessibility.speakThisText': 'Citește acest text',
    'accessibility.pressToSpeak': 'Apasă Alt+Spațiu pentru a citi',
    'accessibility.textToSpeechChanged': 'Citirea vocală a fost modificată',
    
    // Other Options
    'accessibility.reducedMotion': 'Mișcări reduse',
    'accessibility.reducedMotionChanged': 'Setarea pentru mișcări reduse a fost modificată',
    'accessibility.focusIndicator': 'Indicator de focus îmbunătățit',
    'accessibility.focusIndicatorChanged': 'Indicatorul de focus a fost modificat',
    'accessibility.dyslexiaFont': 'Font pentru dislexie',
    'accessibility.dyslexiaFontChanged': 'Fontul pentru dislexie a fost modificat',
    'accessibility.lineSpacing': 'Spațiere între linii mărită',
    'accessibility.lineSpacingChanged': 'Spațierea între linii a fost modificată',
    'accessibility.underlineLinks': 'Subliniază linkurile',
    'accessibility.underlineLinksChanged': 'Sublinierea linkurilor a fost modificată',
    
    // Settings
    'accessibility.resetSettings': 'Resetează setările',
    'accessibility.settingsReset': 'Setările de accesibilitate au fost resetate',
    
    // Keyboard Shortcuts
    'accessibility.keyboardShortcuts': 'Scurtături de tastatură',
    'accessibility.openPanelShortcut': 'Deschide panelul de accesibilitate',
    'accessibility.toggleSpeechShortcut': 'Activează/dezactivează citirea vocală',
    'accessibility.closePanelShortcut': 'Închide panelul',
    'accessibility.skipToContent': 'Sari la conținutul principal',
    'accessibility.mainContent': 'Conținutul principal',
    
    // Footer
    'footer.about': 'Despre noi',
    'footer.contact': 'Contact',
    'footer.privacy': 'Politica de confidențialitate',
    'footer.terms': 'Termeni și condiții',
    'footer.help': 'Ajutor',
    'footer.sitemap': 'Harta site-ului',
    'footer.social': 'Urmărește-ne',
    'footer.newsletter': 'Abonează-te la newsletter',
    'footer.rights': 'Toate drepturile rezervate',
    
    // Navigation
    'nav.previous': 'Anterior',
    'nav.next': 'Următorul',
    'nav.first': 'Prima',
    'nav.last': 'Ultima',
    'nav.goTo': 'Mergi la',
    'nav.page': 'Pagina',
    
    // Common
    'common.loading': 'Se încarcă...',
    'common.error': 'A apărut o eroare',
    'common.close': 'Închide',
    'common.save': 'Salvează',
    'common.cancel': 'Anulează',
    'common.delete': 'Șterge',
    'common.edit': 'Editează',
    'common.view': 'Vezi',
    'common.download': 'Descarcă',
    'common.share': 'Partajează',
    'common.print': 'Printează',
    'common.yes': 'Da',
    'common.no': 'Nu',
    'common.ok': 'OK',
    'common.back': 'Înapoi',
    'common.continue': 'Continuă',
    'common.finish': 'Finalizează',
    'common.search': 'Caută',
    'common.filter': 'Filtrează',
    'common.sort': 'Sortează',
    'common.date': 'Data',
    'common.name': 'Nume',
    'common.title': 'Titlu',
    'common.author': 'Autor',
    'common.category': 'Categorie',
    'common.language': 'Limba',
    'common.year': 'Anul',
    'common.status': 'Statusul',
    'common.actions': 'Acțiuni',
    'common.details': 'Detalii',
    'common.description': 'Descriere',
    'common.available': 'Disponibil',
    'common.unavailable': 'Indisponibil',
    'common.new': 'Nou',
    'common.popular': 'Popular',
    'common.featured': 'Recomandat',
    'common.free': 'Gratuit',
    'common.premium': 'Premium',
    
    // Admin
    'admin.addBook': 'Adaugă carte',
    'admin.manageBooks': 'Gestionează cărți',
    'admin.uploadSingle': 'Upload o singură carte',
    'admin.uploadMultiple': 'Upload multiplu',
    'admin.title': 'Titlu',
    'admin.author': 'Autor',
    'admin.description': 'Descriere',
    'admin.category': 'Categorie',
    'admin.publishedYear': 'An publicare',
    'admin.file': 'Fișier',
    'admin.coverImage': 'Imagine copertă',
    'admin.selectCategory': 'Selectează categoria',
    'admin.addNewCategory': 'Adaugă categorie nouă',
    'admin.newCategoryPlaceholder': 'Numele noii categorii',
    'admin.add': 'Adaugă',
    'admin.cancel': 'Anulează',
    'admin.required': 'obligatoriu',
    'admin.optional': 'opțional',
    'admin.isbn': 'ISBN',
    'admin.searchByTitleAuthor': 'Caută după titlu/autor',
    'admin.searching': 'Se caută...',
    'admin.uploadBooks': 'Încarcă cărțile',
    'admin.reset': 'Resetează',
    'admin.uploading': 'Se încarcă...',
    'admin.uploadSuccess': 'Carte adăugată cu succes!',
    'admin.uploadError': 'Eroare la încărcarea cărții',
    'admin.fillRequiredFields': 'Vă rugăm să completați toate câmpurile obligatorii',
    'admin.dragDropFiles': 'Trageți fișierele aici sau faceți clic pentru a selecta',
    'admin.selectedFiles': 'Fișiere selectate',
    'admin.commonCategory': 'opțional, comun pentru toate cărțile',
    'admin.metadataHelp': 'Introduceți ISBN-ul sau completați titlul/autorul pentru a căuta automat informațiile cărții',
  },
  
  en: {
    // Header
    'header.home': 'Home',
    'header.books': 'Books',
    'header.recommendations': 'Recommendations',
    'header.favorites': 'Favorites',
    'header.copyright': 'Copyright',
    'header.profile': 'My Profile',
    'header.logout': 'Logout',
    'header.login': 'Login',
    'header.register': 'Register',
    
    // Hero Section
    'hero.title': 'Discover the world of knowledge through',
    'hero.subtitle': 'Digital Library',
    'hero.description': 'Access a vast collection of books, academic journals and multimedia materials. All resources are available online, for free.',
    'hero.explore': 'Explore library',
    'hero.about': 'About us',
    'hero.changeLanguage': 'Change language',
    'hero.languageDescription': 'Select your preferred interface language',
    
    // Language Selector
    'language.select': 'Select language',
    'language.help': 'Translation help',
    'language.comingSoon': 'Coming soon',
    
    // Search
    'search.placeholder': 'Search books, authors, categories...',
    'search.button': 'Search',
    'search.advanced': 'Advanced search',
    'search.hideAdvanced': 'Hide advanced search',
    'search.resultsFor': 'Results for',
    'search.noResults': 'No results found for',
    'search.tryAnother': 'Try another search or explore the categories below.',
    'search.title': 'Title',
    'search.author': 'Author',
    'search.category': 'Category',
    'search.year': 'Publication year',
    'search.language': 'Language',
    'search.from': 'From',
    'search.to': 'To',
    'search.apply': 'Apply filters',
    'search.clear': 'Clear filters',
    'search.selectCategory': 'Select category',
    'search.selectLanguage': 'Select language',
    
    // Tabs
    'tabs.booksCategories': 'Books & Categories',
    'tabs.specialCollections': 'Special Collections',
    'tabs.recommendations': 'Personalized Recommendations',
    'tabs.resources': 'Integrated Resources',
    
    // Categories
    'categories.popular': 'Popular categories',
    'categories.fiction': 'Fiction',
    'categories.nonFiction': 'Non-Fiction',
    'categories.science': 'Science',
    'categories.academic': 'Academic',
    'categories.biography': 'Biography',
    'categories.poetry': 'Poetry',
    'categories.resources': 'resources',
    
    // Books
    'books.recentlyAdded': 'Recently added books',
    'books.readMore': 'Read more',
    'books.readLess': 'Read less',
    'books.pages': 'pages',
    'books.year': 'Year',
    'books.language': 'Language',
    'books.category': 'Category',
    'books.addToFavorites': 'Add to favorites',
    'books.removeFromFavorites': 'Remove from favorites',
    'books.download': 'Download',
    'books.preview': 'Preview',
    'books.details': 'Details',
    
    // Book Reader
    'reader.title': 'Book Reader',
    'reader.page': 'Page',
    'reader.of': 'of',
    'reader.previousPage': 'Previous page',
    'reader.nextPage': 'Next page',
    'reader.close': 'Close',
    'reader.bookmark': 'Bookmark',
    'reader.notes': 'Notes',
    'reader.search': 'Search in book',
    'reader.fontSize': 'Font size',
    'reader.nightMode': 'Night mode',
    
    // Special Collections
    'collections.title': 'Special Collections',
    'collections.viewAll': 'View all',
    'collections.items': 'items',
    'collections.featured': 'Featured',
    'collections.rareManuscripts': 'Rare Manuscripts',
    'collections.historicalMaps': 'Historical Maps',
    'collections.oldNewspapers': 'Old Newspapers',
    'collections.type': 'Type',
    'collections.year': 'Year',
    
    // Recommendations
    'recommendations.title': 'Personalized Recommendations',
    'recommendations.forYou': 'For you',
    'recommendations.basedOnHistory': 'Based on your recent history',
    'recommendations.popularInGenre': 'Popular in your preferred categories',
    'recommendations.newArrivals': 'New arrivals',
    'recommendations.trending': 'Trending',
    'recommendations.becauseYouRead': 'Because you read',
    'recommendations.similarReaders': 'Readers with similar tastes chose',
    'recommendations.loginRequired': 'Login for personalized recommendations',
    
    // External Resources
    'resources.title': 'Integrated Resources',
    'resources.externalLibraries': 'External libraries',
    'resources.available': 'Available',
    'resources.restricted': 'Restricted access',
    'resources.subscription': 'Subscription required',
    'resources.book': 'Book',
    'resources.article': 'Article',
    'resources.thesis': 'Thesis',
    'resources.audio': 'Audio',
    'resources.video': 'Video',
    'resources.source': 'Source',
    'resources.openExternal': 'Open in external library',
    
    // User Reviews
    'reviews.title': 'User reviews',
    'reviews.addReview': 'Add a review',
    'reviews.rating': 'Rating',
    'reviews.writeReview': 'Write a review',
    'reviews.submit': 'Submit review',
    'reviews.like': 'Like',
    'reviews.reply': 'Reply',
    'reviews.likes': 'likes',
    'reviews.replies': 'replies',
    'reviews.loginToReview': 'Login to leave a review',
    'reviews.helpful': 'Helpful',
    'reviews.notHelpful': 'Not helpful',
    
    // User Profile
    'profile.title': 'My Profile',
    'profile.edit': 'Edit profile',
    'profile.reading': 'Currently reading',
    'profile.completed': 'Completed',
    'profile.favorites': 'Favorites',
    'profile.reviews': 'My reviews',
    'profile.settings': 'Settings',
    'profile.privacy': 'Privacy',
    'profile.notifications': 'Notifications',
    'profile.preferences': 'Preferences',
    
    // Authentication
    'auth.login': 'Login',
    'auth.register': 'Register',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.confirmPassword': 'Confirm password',
    'auth.firstName': 'First name',
    'auth.lastName': 'Last name',
    'auth.rememberMe': 'Remember me',
    'auth.forgotPassword': 'Forgot password',
    'auth.noAccount': "Don't have an account?",
    'auth.hasAccount': 'Already have an account?',
    'auth.loginError': 'Incorrect email or password',
    'auth.registerSuccess': 'Account created successfully',
    'auth.logout': 'Logout',
    
    // Forms
    'form.required': 'Required field',
    'form.invalidEmail': 'Invalid email',
    'form.passwordTooShort': 'Password must be at least 6 characters',
    'form.passwordsNotMatch': 'Passwords do not match',
    'form.save': 'Save',
    'form.cancel': 'Cancel',
    'form.edit': 'Edit',
    'form.delete': 'Delete',
    'form.confirm': 'Confirm',
    
    // Copyright
    'copyright.title': 'Copyright Protection',
    'copyright.description': 'Our digital library respects and protects copyright for all available materials.',
    'copyright.learnMore': 'Learn more about our copyright policies',
    'copyright.fairUse': 'Fair use',
    'copyright.educational': 'Educational use',
    'copyright.publicDomain': 'Public domain',
    'copyright.restrictions': 'Usage restrictions',
    'copyright.contact': 'Rights contact',
    
    // Accessibility
    'accessibility.title': 'Accessibility Options',
    'accessibility.description': 'Personalize your reading experience for special needs',
    'accessibility.available': 'Accessibility available',
    'accessibility.openPanel': 'Open accessibility panel',
    'accessibility.closePanel': 'Close accessibility panel',
    
    // Font Size
    'accessibility.fontSize': 'Text size',
    'accessibility.fontSize.small': 'Small',
    'accessibility.fontSize.medium': 'Medium',
    'accessibility.fontSize.large': 'Large',
    'accessibility.fontSize.extra-large': 'Extra large',
    'accessibility.fontSizeChanged': 'Text size changed',
    
    // Contrast
    'accessibility.contrast': 'Contrast',
    'accessibility.contrast.normal': 'Normal',
    'accessibility.contrast.high': 'High',
    'accessibility.contrastChanged': 'Contrast changed',
    
    // Text-to-Speech
    'accessibility.textToSpeech': 'Text-to-speech',
    'accessibility.toggleTextToSpeech': 'Toggle text-to-speech',
    'accessibility.testSpeech': 'Test text-to-speech',
    'accessibility.stopSpeech': 'Stop speech',
    'accessibility.speaking': 'Speaking',
    'accessibility.speakThisText': 'Speak this text',
    'accessibility.pressToSpeak': 'Press Alt+Space to speak',
    'accessibility.textToSpeechChanged': 'Text-to-speech changed',
    
    // Other Options
    'accessibility.reducedMotion': 'Reduced motion',
    'accessibility.reducedMotionChanged': 'Reduced motion setting changed',
    'accessibility.focusIndicator': 'Improved focus indicator',
    'accessibility.focusIndicatorChanged': 'Focus indicator changed',
    'accessibility.dyslexiaFont': 'Dyslexia font',
    'accessibility.dyslexiaFontChanged': 'Dyslexia font changed',
    'accessibility.lineSpacing': 'Increased line spacing',
    'accessibility.lineSpacingChanged': 'Line spacing changed',
    'accessibility.underlineLinks': 'Underline links',
    'accessibility.underlineLinksChanged': 'Underline links changed',
    
    // Settings
    'accessibility.resetSettings': 'Reset settings',
    'accessibility.settingsReset': 'Accessibility settings reset',
    
    // Keyboard Shortcuts
    'accessibility.keyboardShortcuts': 'Keyboard shortcuts',
    'accessibility.openPanelShortcut': 'Open accessibility panel',
    'accessibility.toggleSpeechShortcut': 'Toggle text-to-speech',
    'accessibility.closePanelShortcut': 'Close panel',
    
    // Footer
    'footer.about': 'About us',
    'footer.contact': 'Contact',
    'footer.privacy': 'Privacy policy',
    'footer.terms': 'Terms and conditions',
    'footer.help': 'Help',
    'footer.sitemap': 'Sitemap',
    'footer.social': 'Follow us',
    'footer.newsletter': 'Subscribe to newsletter',
    'footer.rights': 'All rights reserved',
    
    // Navigation
    'nav.previous': 'Previous',
    'nav.next': 'Next',
    'nav.first': 'First',
    'nav.last': 'Last',
    'nav.goTo': 'Go to',
    'nav.page': 'Page',
    
    // Common
    'common.loading': 'Loading...',
    'common.error': 'An error occurred',
    'common.close': 'Close',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.view': 'View',
    'common.download': 'Download',
    'common.share': 'Share',
    'common.print': 'Print',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.ok': 'OK',
    'common.back': 'Back',
    'common.continue': 'Continue',
    'common.finish': 'Finish',
    'common.search': 'Search',
    'common.filter': 'Filter',
    'common.sort': 'Sort',
    'common.date': 'Date',
    'common.name': 'Name',
    'common.title': 'Title',
    'common.author': 'Author',
    'common.category': 'Category',
    'common.language': 'Language',
    'common.year': 'Year',
    'common.status': 'Status',
    'common.actions': 'Actions',
    'common.details': 'Details',
    'common.description': 'Description',
    'common.available': 'Available',
    'common.unavailable': 'Unavailable',
    'common.new': 'New',
    'common.popular': 'Popular',
    'common.featured': 'Featured',
    'common.free': 'Free',
    'common.premium': 'Premium',
    
    // Admin
    'admin.addBook': 'Add Book',
    'admin.manageBooks': 'Manage Books',
    'admin.uploadSingle': 'Upload Single Book',
    'admin.uploadMultiple': 'Multiple Upload',
    'admin.title': 'Title',
    'admin.author': 'Author',
    'admin.description': 'Description',
    'admin.category': 'Category',
    'admin.publishedYear': 'Published Year',
    'admin.file': 'File',
    'admin.coverImage': 'Cover Image',
    'admin.selectCategory': 'Select category',
    'admin.addNewCategory': 'Add new category',
    'admin.newCategoryPlaceholder': 'New category name',
    'admin.add': 'Add',
    'admin.cancel': 'Cancel',
    'admin.required': 'required',
    'admin.optional': 'optional',
    'admin.isbn': 'ISBN',
    'admin.searchByTitleAuthor': 'Search by title/author',
    'admin.searching': 'Searching...',
    'admin.uploadBooks': 'Upload Books',
    'admin.reset': 'Reset',
    'admin.uploading': 'Uploading...',
    'admin.uploadSuccess': 'Book added successfully!',
    'admin.uploadError': 'Error uploading book',
    'admin.fillRequiredFields': 'Please fill in all required fields',
    'admin.dragDropFiles': 'Date files here or click to select',
    'admin.selectedFiles': 'Selected files',
    'admin.commonCategory': 'optional, common for all books',
    'admin.metadataHelp': 'Enter ISBN or fill in title/author to automatically search for book information',
  },
  
  fr: {
    // Header
    'header.home': 'Accueil',
    'header.books': 'Livres',
    'header.recommendations': 'Recommandations',
    'header.favorites': 'Favoris',
    'header.copyright': 'Droits d\'auteur',
    'header.profile': 'Mon profil',
    'header.logout': 'Déconnexion',
    
    // Hero Section
    'hero.title': 'Découvrez le monde de la connaissance à travers',
    'hero.subtitle': 'Bibliothèque Numérique',
    'hero.description': 'Accédez à une vaste collection de livres, journaux académiques et matériels multimédias. Toutes les ressources sont disponibles en ligne, gratuitement.',
    'hero.explore': 'Explorer la bibliothèque',
    'hero.about': 'À propos de nous',
    'hero.changeLanguage': 'Changer la langue',
    'hero.languageDescription': 'Sélectionnez votre langue d\'interface préférée',
    
    // Language Selector
    'language.select': 'Sélectionner la langue',
    'language.help': 'Aide à la traduction',
    'language.comingSoon': 'Bientôt disponible',
    
    // Search
    'search.placeholder': 'Rechercher livres, auteurs, catégories...',
    'search.button': 'Rechercher',
    'search.advanced': 'Recherche avancée',
    'search.hideAdvanced': 'Masquer la recherche avancée',
    'search.resultsFor': 'Résultats pour',
    'search.noResults': 'Aucun résultat trouvé pour',
    'search.tryAnother': 'Essayez une autre recherche ou explorez les catégories ci-dessous.',
    
    // Tabs
    'tabs.booksCategories': 'Livres et Catégories',
    'tabs.specialCollections': 'Collections Spéciales',
    'tabs.recommendations': 'Recommandations Personnalisées',
    'tabs.resources': 'Ressources Intégrées',
    
    // Categories
    'categories.popular': 'Catégories populaires',
    'categories.fiction': 'Fiction',
    'categories.nonFiction': 'Non-Fiction',
    'categories.science': 'Sciences',
    'categories.academic': 'Académique',
    'categories.biography': 'Biographies',
    'categories.poetry': 'Poésie',
    'categories.resources': 'ressources',
    
    // Recent Books
    'books.recentlyAdded': 'Livres récemment ajoutés',
    
    // Copyright
    'copyright.title': 'Protection des Droits d\'Auteur',
    'copyright.description': 'Notre bibliothèque numérique respecte et protège les droits d\'auteur pour tous les matériaux disponibles.',
    'copyright.learnMore': 'En savoir plus sur nos politiques de droits d\'auteur',
    
    // Common
    'common.loading': 'Chargement...',
    'common.error': 'Une erreur est survenue',
    'common.close': 'Fermer',
    'common.save': 'Enregistrer',
    'common.cancel': 'Annuler',
    
    // Admin
    'admin.addBook': 'Ajouter un livre',
    'admin.manageBooks': 'Gérer les livres',
    'admin.uploadSingle': 'Télécharger un livre',
    'admin.uploadMultiple': 'Téléchargement multiple',
    'admin.title': 'Titre',
    'admin.author': 'Auteur',
    'admin.description': 'Description',
    'admin.category': 'Catégorie',
    'admin.publishedYear': 'Année de publication',
    'admin.file': 'Fichier',
    'admin.coverImage': 'Image de couverture',
    'admin.selectCategory': 'Sélectionner la catégorie',
    'admin.addNewCategory': 'Ajouter une nouvelle catégorie',
    'admin.newCategoryPlaceholder': 'Nom de la nouvelle catégorie',
    'admin.add': 'Ajouter',
    'admin.cancel': 'Annuler',
    'admin.required': 'obligatoire',
    'admin.optional': 'optionnel',
    'admin.isbn': 'ISBN',
    'admin.searchByTitleAuthor': 'Rechercher par titre/auteur',
    'admin.searching': 'Recherche...',
    'admin.uploadBooks': 'Télécharger les livres',
    'admin.reset': 'Réinitialiser',
    'admin.uploading': 'Téléchargement...',
    'admin.uploadSuccess': 'Livre ajouté avec succès!',
    'admin.uploadError': 'Erreur lors du téléchargement',
    'admin.fillRequiredFields': 'Veuillez remplir tous les champs obligatoires',
    'admin.dragDropFiles': 'Faites glisser les fichiers ici ou cliquez pour sélectionner',
    'admin.selectedFiles': 'Fichiers sélectionnés',
    'admin.commonCategory': 'optionnel, commun à tous les livres',
    'admin.metadataHelp': 'Entrez l\'ISBN ou remplissez le titre/auteur pour rechercher automatiquement les informations',
  },
  
  de: {
    // Header
    'header.home': 'Startseite',
    'header.books': 'Bücher',
    'header.recommendations': 'Empfehlungen',
    'header.favorites': 'Favoriten',
    'header.copyright': 'Urheberrecht',
    'header.profile': 'Mein Profil',
    'header.logout': 'Abmelden',
    
    // Hero Section
    'hero.title': 'Entdecken Sie die Welt des Wissens durch',
    'hero.subtitle': 'Digitale Bibliothek',
    'hero.description': 'Zugang zu einer umfangreichen Sammlung von Büchern, wissenschaftlichen Zeitschriften und Multimedia-Materialien. Alle Ressourcen sind online und kostenlos verfügbar.',
    'hero.explore': 'Bibliothek erkunden',
    'hero.about': 'Über uns',
    'hero.changeLanguage': 'Sprache ändern',
    'hero.languageDescription': 'Wählen Sie Ihre bevorzugte Sprache für die Benutzeroberfläche',
    
    // Language Selector
    'language.select': 'Sprache auswählen',
    'language.help': 'Übersetzungshilfe',
    'language.comingSoon': 'Demnächst verfügbar',
    
    // Search
    'search.placeholder': 'Bücher, Autoren, Kategorien suchen...',
    'search.button': 'Suchen',
    'search.advanced': 'Erweiterte Suche',
    'search.hideAdvanced': 'Erweiterte Suche ausblenden',
    'search.resultsFor': 'Ergebnisse für',
    'search.noResults': 'Keine Ergebnisse gefunden für',
    'search.tryAnother': 'Versuchen Sie eine andere Suche oder erkunden Sie die Kategorien unten.',
    
    // Tabs
    'tabs.booksCategories': 'Bücher & Kategorien',
    'tabs.specialCollections': 'Spezialsammlungen',
    'tabs.recommendations': 'Personalisierte Empfehlungen',
    'tabs.resources': 'Integrierte Ressourcen',
    
    // Categories
    'categories.popular': 'Beliebte Kategorien',
    'categories.fiction': 'Belletristik',
    'categories.nonFiction': 'Sachbuch',
    'categories.science': 'Wissenschaft',
    'categories.academic': 'Akademisch',
    'categories.biography': 'Biografien',
    'categories.poetry': 'Poesie',
    'categories.resources': 'Ressourcen',
    
    // Recent Books
    'books.recentlyAdded': 'Kürzlich hinzugefügte Bücher',
    
    // Copyright
    'copyright.title': 'Urheberrechtsschutz',
    'copyright.description': 'Unsere digitale Bibliothek respektiert und schützt die Urheberrechte für alle verfügbaren Materialien.',
    'copyright.learnMore': 'Erfahren Sie mehr über unsere Urheberrechtsrichtlinien',
    
    // Common
    'common.loading': 'Lädt...',
    'common.error': 'Ein Fehler ist aufgetreten',
    'common.close': 'Schließen',
    'common.save': 'Speichern',
    'common.cancel': 'Abbrechen',
    
    // Admin
    'admin.addBook': 'Buch hinzufügen',
    'admin.manageBooks': 'Bücher verwalten',
    'admin.uploadSingle': 'Einzelnes Buch hochladen',
    'admin.uploadMultiple': 'Mehrfach-Upload',
    'admin.title': 'Titel',
    'admin.author': 'Autor',
    'admin.description': 'Beschreibung',
    'admin.category': 'Kategorie',
    'admin.publishedYear': 'Erscheinungsjahr',
    'admin.file': 'Datei',
    'admin.coverImage': 'Titelbild',
    'admin.selectCategory': 'Kategorie auswählen',
    'admin.addNewCategory': 'Neue Kategorie hinzufügen',
    'admin.newCategoryPlaceholder': 'Name der neuen Kategorie',
    'admin.add': 'Hinzufügen',
    'admin.cancel': 'Abbrechen',
    'admin.required': 'erforderlich',
    'admin.optional': 'optional',
    'admin.isbn': 'ISBN',
    'admin.searchByTitleAuthor': 'Nach Titel/Autor suchen',
    'admin.searching': 'Suche läuft...',
    'admin.uploadBooks': 'Bücher hochladen',
    'admin.reset': 'Zurücksetzen',
    'admin.uploading': 'Wird hochgeladen...',
    'admin.uploadSuccess': 'Buch erfolgreich hinzugefügt!',
    'admin.uploadError': 'Fehler beim Hochladen des Buchs',
    'admin.fillRequiredFields': 'Bitte füllen Sie alle Pflichtfelder aus',
    'admin.dragDropFiles': 'Dateien hier hinziehen oder klicken zum Auswählen',
    'admin.selectedFiles': 'Ausgewählte Dateien',
    'admin.commonCategory': 'optional, gemeinsam für alle Bücher',
    'admin.metadataHelp': 'ISBN eingeben oder Titel/Autor ausfüllen, um automatisch nach Buchinformationen zu suchen',
  }
};

interface LanguageContextType {
  currentLanguage: string;
  setLanguage: (language: string) => void;
  t: (key: string) => string;
  availableLanguages: Array<{
    code: string;
    name: string;
    flag: string;
    active: boolean;
  }>;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

const availableLanguages = [
  { code: "ro", name: "Română", flag: "🇷🇴", active: true }
];

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('ro');

  const setLanguage = (language: string) => {
    const selectedLang = availableLanguages.find(lang => lang.code === language && lang.active);
    if (selectedLang) {
      setCurrentLanguage(language);
      localStorage.setItem('preferredLanguage', language);
      
      // Schimbăm și limba documentului pentru screen readeri
      document.documentElement.lang = language;
    }
  };

  const t = (key: string): string => {
    const translation = translations[currentLanguage]?.[key];
    if (translation) {
      return translation;
    }
    
    // Fallback la română dacă traducerea nu există
    const fallback = translations['ro']?.[key];
    if (fallback) {
      return fallback;
    }
    
    // Returnăm cheia dacă nu găsim traducerea
    return key;
  };

  useEffect(() => {
    // Setăm limba documentului la încărcare
    document.documentElement.lang = currentLanguage;
  }, [currentLanguage]);

  return (
    <LanguageContext.Provider value={{
      currentLanguage,
      setLanguage,
      t,
      availableLanguages
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}; 
